'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import DeviceIcon from 'Icons/DeviceIcon';
import PaperPlaneIcon from 'Icons/PaperPlaneIcon';
import LoginForm from 'Components/Forms/LoginForm';
import Button from '@material-ui/core/Button';
import Breadcrumb from 'Components/Front/Breadcrumb';
import GLOBAL_CONFIG from 'Shared/config';
import bemit from 'Functions/bemit';
import { front_urls, URL } from 'Shared/Routes';
let app = typeof window !== 'undefined' ? window.app : undefined;
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Connexion Administrateur entreprise',
  url: URL('CompanyLogin')
}];
export default class CompanyLoginPage extends Component {
  state = {};
  onContactClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    app.emit({
      event: 'TC_Click',
      source: 'CompanyLoginPage',
      data: {
        e: e,
        action: 'contact_conseiller'
      }
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Connexion Administrateur entreprise"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['static-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "Connexion Administrateur entreprise")))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), /*#__PURE__*/React.createElement(LoginForm, null), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info u-margin-top-40"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col c-pack__info-col--shadow"
    }, /*#__PURE__*/React.createElement(DeviceIcon, {
      className: "c-pack__info-col-icon"
    }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Vous souhaitez acc\xE9der \xE0 votre compte")), /*#__PURE__*/React.createElement("p", null, "Retrouvez un service personnalis\xE9 pour l'achat et le suivi de vos cr\xE9dits"), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
      href: URL('CompanyCreateAccount'),
      component: Link
    }, "Cr\xE9er mon compte entreprise"))), /*#__PURE__*/React.createElement("div", {
      className: "c-pack__info-col"
    }, /*#__PURE__*/React.createElement(PaperPlaneIcon, {
      className: "c-pack__info-col-icon"
    }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Vous souhaitez en savoir plus ?")), /*#__PURE__*/React.createElement("p", null, "Un expert myWO est disponible pour r\xE9pondre \xE0 toutes vos questions"), /*#__PURE__*/React.createElement("a", {
      className: bemit('c-flat-btn', ['front', 'blue', 'spaces-types-block']),
      onClick: component.onContactClick,
      href: "mailto:commercial@mywo.fr"
    }, "Contacter un conseiller")))));
    return output;
  }
}
